import { Typography } from "@mui/material";
import React from "react";

function About() {
  return (
    <div className="px-3 py-4" id="about">
      <div className="row align-items-center g-4">
        <h4 className="mb-4 fw-bold text-center text-md-start">About Us</h4>

        {/* Text section */}
        <div className="col-12 col-md-6">
          <Typography
            sx={{
              textAlign: "justify",
              fontSize: { xs: "0.9rem", sm: "1rem" },
              lineHeight: 1.8,
            }}
          >
            <b>Karnafully International</b> was emerged in beginning 2010 by one
            young entrepreneurs with a belief that a proper creative execution
            of the brand can help it solely to create a position in the market.
            <br />
            <br />
            Undoubtedly advertising adds value to the product as well services,
            but it requires an integrated plan. To{" "}
            <b>Karnafully International</b>, an integrated communication
            strategy is the prime concern to make the bridge between the
            services and consumers. This the way we consider the customers'
            perception while developing a strategy.
            <br />
            <br />
            A proper panel of adequate people - experienced enough in brand
            development strategy is working with us. To support the planning
            development we are equipped with other members working in market
            research, consumer behavioral study and brand audit. Our creative
            team is aware of the personality of the brand; this team knows it
            very well how a creative message and idea can be communicated with
            different segments of consumers. And the execution is done keeping
            the image of the brand as well as its target audience.
            <br />
            <br />
            The combination of the above is creating an unparallel room for us
            to sustain in this competitive edge.
          </Typography>
        </div>

        {/* Image section */}
        <div className="col-12 col-md-6 text-center">
          <img
            src={require("../assets/images/aboutus.jpg")}
            alt="karnafully"
            className="img-fluid rounded shadow-sm"
            style={{ maxHeight: "450px", objectFit: "cover" }}
          />
        </div>
      </div>
    </div>
  );
}

export default About;
